import EventList from "./EventList"
import {useLang} from '../components/LangProvider'
import { Link } from "react-router-dom"
import DocumentsList from "./DocumentsList";

function Footer(){

  const {lang} = useLang()

  return <footer>
    <div className="container">
      <div className="register">
        <h4>{lang["footer register title"]}</h4>
        <ol>
          <li dangerouslySetInnerHTML={{__html: lang["footer register step 1"]}}></li>
          <li dangerouslySetInnerHTML={{__html: lang["footer register step 2"]}}></li>
          <li dangerouslySetInnerHTML={{__html: lang["footer register step 3"]}}></li>
          <li dangerouslySetInnerHTML={{__html: lang["footer register step 4"]}}></li>
        </ol>
        {/*<Link to="/document/conf">{lang["footer register confidency text"]}</Link>*/}
        {/*<Link to="/document/offer">{lang["footer register offert text"]}</Link>*/}
        {/*<Link to="/document/deal">{lang["footer register deal text"]}</Link>*/}
        <DocumentsList />
        <img src="/assets/images/masterCard-visa.png" alt="" />
      </div>
      <div className="future-events">
        <h4>{lang["footer events title"]}</h4>
        <EventList />
        <img src="/assets/images/european-athletic-min.png" alt="" />
        <img src="/assets/images/aims.png" alt="" />
        <img src="/assets/images/race.png" alt="" />
      </div>
      <div className="results">
        <h4>{lang["footer results title"]}</h4>
      </div>
      <div className="contacts">
        <h4>{lang["footer contacts title"]}</h4>
        <span>{lang["footer contacts participants"]}</span>
        <a href={"mailto:"+lang["footer contacts participants mail"]}>{lang["footer contacts participants mail"]}</a>
        <span>{lang["footer contacts corporate teams"]}</span>
        <a href={"mailto:"+lang["footer contacts corporate teams mail"]}>{lang["footer contacts corporate teams mail"]}</a>
        <span>{lang["footer contacts partners"]}</span>
        <a href={"mailto:"+lang["footer contacts partners mail"]}>{lang["footer contacts partners mail"]}</a>
        <span>{lang["footer contacts volunteers"]}</span>
        <a href={"mailto:"+lang["footer contacts volunteers mail"]}>{lang["footer contacts volunteers mail"]}</a>
        <div className="socials">
          <a href={lang["socials telegram link"]}><span className="fa telegram"></span></a>
          <a href={lang["socials instagram link"]}><span className="fa instagram"></span></a>
          <a href={lang["socials facebook link"]}><span className="fa facebook"></span></a>
        </div>
        <img src="/assets/images/logo.svg" alt="" />
      </div>
      <div className="credentials">
        <div>
          <p>{lang["footer organisation credentials"]}</p>
        </div>
        <div>
          <p>{lang["footer organisation director title"]}</p>
          <p><strong>{lang["footer organisation direcot name"]}</strong></p>
        </div>
        <div>
          <p>{lang["footer organisation registration number title"]}</p>
          <p>{lang["footer organisation registration number data"]}</p>
        </div>
      </div>
    </div>
  </footer>
}

export default Footer